"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEAM = exports.BILLING = void 0;
var BILLING = 'billing';
exports.BILLING = BILLING;
var TEAM = 'team';
exports.TEAM = TEAM;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/AdminTypes.js
// module id = 201
// module chunks = 5 6